import React from 'react';
import './Examples.scss';
import Assets from './Assets';
import Events from './Events';
import Transactions from './Transactions';
import Blocks from './Blocks';
import Service from './Service';
import Bundles from './Bundles';
import { Anchor } from 'src/app/components';
import { GradientText } from '@ambrosus/react';

const Examples = () => {

  return (
    <div id='examples'>
      <h2><GradientText colors={['#00B7F9', '#0042BA', '#5B1EC0']} fontWeight={300} size={36}>Examples</GradientText><Anchor hash='examples' /></h2>

      <Assets />
      <Events />
      <Bundles />
      <Transactions />
      <Blocks />
      <Service />
    </div>);
};

export default Examples;
